import React from 'react';

import { Box, Text, TextProps } from '@chakra-ui/react';

import { CustomTooltip, CustomTooltipStyles } from 'components/DataDisplay';

export interface EllipsisTextProps extends TextProps {
  label?: React.ReactNode;
  tooltip?: React.ReactNode;
  tooltipStyle?: CustomTooltipStyles;
  showTooltip?: boolean;
}

export const EllipsisText: React.FC<EllipsisTextProps> = props => {
  const {
    label,
    tooltip,
    tooltipStyle,
    showTooltip = true,
    children,
    ...rest
  } = props;

  const renderContent = () => (
    <Text noOfLines={1} flex={1} {...rest}>
      {label ?? children}
    </Text>
  );

  return !label && !children ? (
    <Box>-</Box>
  ) : showTooltip ? (
    <CustomTooltip label={tooltip ?? label ?? children} styles={tooltipStyle}>
      {renderContent()}
    </CustomTooltip>
  ) : (
    renderContent()
  );
};
